import React, { useEffect, useState } from "react";
import { Library, Bot, Boxes, Plug, ShieldAlert, AlertTriangle, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/Layout";
import { Card } from "@/components/ModulePage";

function Stat({ icon: Icon, label, value }) {
  return <Card className="flex items-center gap-3"><div className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary/20"><Icon className="h-5 w-5 text-accent" /></div><div><div className="text-2xl font-bold">{value}</div><div className="text-xs text-muted-foreground">{label}</div></div></Card>;
}

export default function Aioc() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/aioc").then(({ data }) => setD(data)).catch(() => {}); }, []);
  if (!d) return <div className="flex justify-center py-20"><Loader2 className="h-6 w-6 animate-spin text-accent" /></div>;
  const raCtx = `AI Operations Center. ${d.use_cases} use cases, ${d.agents} agents, ${d.models} models, ${d.integrations} integrations. Open incidents ${d.open_incidents}, open risks ${d.open_risks}. Operating tiers: ${d.tiers.join(", ")}.`;
  return (
    <div>
      <PageHeader title="AIOC — AI Operations Center" subtitle="Inventory, operations, incidents and risk across all AI assets, run on a four-tier operating model." readAloudContext={raCtx} />
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-3 xl:grid-cols-6">
        <Stat icon={Library} label="Use Cases" value={d.use_cases} />
        <Stat icon={Bot} label="Agents" value={d.agents} />
        <Stat icon={Boxes} label="Models" value={d.models} />
        <Stat icon={Plug} label="Integrations" value={d.integrations} />
        <Stat icon={ShieldAlert} label="Open Incidents" value={d.open_incidents} />
        <Stat icon={AlertTriangle} label="Open Risks" value={d.open_risks} />
      </div>
      <Card className="mt-6">
        <h3 className="mb-3 text-sm font-semibold">Operating Model</h3>
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {d.tiers.map((t, i) => (
            <div key={t} className="rounded-xl border border-border bg-secondary/20 p-4">
              <div className="mb-1 text-xs font-semibold text-accent">Tier {i + 1}</div>
              <div className="text-sm">{t}</div>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}
